module.exports = __webpack_public_path__ + "static/media/beta.8d800a77.svg";